import React from 'react';
import styled from 'styled-components';
import WaveDivider from './WaveDivider.jsx';

// Styled Components
const LanguagesSection = styled.section`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  margin-bottom: 0;
  padding: 4rem 0 10rem 0;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  margin-top: var(--section-push-up);
  position: relative;
  overflow: hidden;
  isolation: isolate;
`;

const LanguagesContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const SectionTitle = styled.h2`
  color: white;
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  position: relative;
  font-family: var(--font-heading);
  font-weight: 700;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
  }
`;

const LanguagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1.5rem;
  margin-top: 2rem;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const LanguageCard = styled.div`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.15);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  }
`;

const LanguageHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;

  i {
    font-size: 2rem;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 0.5rem;
  }

  h3 {
    font-family: var(--font-heading);
    font-size: 1.1rem;
    color: white;
    margin: 0;
    font-weight: 600;
  }
`;

const LanguageLevel = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  margin-bottom: 1rem;
  font-family: var(--font-body);
`;

const LanguageProgress = styled.div`
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  height: 6px;
  overflow: hidden;
  margin-bottom: 0.5rem;
`;

const ProgressBar = styled.div`
  background: rgba(255, 255, 255, 0.8);
  height: 100%;
  border-radius: 10px;
  transition: width 0.8s ease;
  width: ${props => props.proficiency}%;
`;

const Languages = () => {
  const languages = [
    {
      language: 'Deutsch',
      level: 'Muttersprache',
      proficiency: 100,
      icon: 'fas fa-flag'
    },
    {
      language: 'Russisch',
      level: 'Zweitmuttersprache',
      proficiency: 95,
      icon: 'fas fa-flag'
    },
    {
      language: 'Englisch',
      level: 'Sehr gut - C1',
      proficiency: 85,
      icon: 'fas fa-flag'
    },
    {
      language: 'Spanisch',
      level: 'Grundkenntnisse - A2',
      proficiency: 40,
      icon: 'fas fa-flag'
    },
    {
      language: 'Französisch',
      level: 'Grundkenntnisse - A2',
      proficiency: 35,
      icon: 'fas fa-flag'
    }
  ];

  return (
    <LanguagesSection id="languages">
      <LanguagesContainer>
        <SectionTitle>Sprachkenntnisse</SectionTitle>
        <LanguagesGrid>
          {languages.map((lang, index) => (
            <LanguageCard key={index}>
              <LanguageHeader>
                <i className={lang.icon}></i>
                <h3>{lang.language}</h3>
              </LanguageHeader>
              <LanguageLevel>{lang.level}</LanguageLevel>
              <LanguageProgress>
                <ProgressBar proficiency={lang.proficiency} />
              </LanguageProgress>
            </LanguageCard>
          ))}
        </LanguagesGrid>
      </LanguagesContainer>
      <WaveDivider 
        color="blue" 
        variant="smooth" 
        animated={true}
        height={120}
      />
    </LanguagesSection>
  );
};

export default Languages; 